export default __webpack_public_path__ + "static/media/video12.acba04b1.webp";